import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH AGREEMENT TO EDIT ********************
export const fetchAgreement = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_AGREEMENT_LOADING,
			payload: true
		});

		const response = await services.get(`/agreements/${id}`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_AGREEMENT_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_AGREEMENT_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
